import { CandidateProfileFormData } from 'features/profile/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedSwitch, InfoLine } from 'shared/components';

interface PreferenceCheckboxesProps {
    disabled?: boolean;
}

export default function PreferenceCheckboxes({ disabled }: PreferenceCheckboxesProps) {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    return (
        <>
            <InfoLine
                title={ t('view.communicationPreferences.engagementCampaign.title') }
                description={ t('view.communicationPreferences.engagementCampaign.description') }
                trailing={ <ConnectedSwitch control={ control }
                    name="communicationPreferences.engagementCampaign"
                    disabled={ disabled }
                /> }
            />

            <InfoLine
                title={ t('view.communicationPreferences.candidateAvailabilityRequests.title') }
                description={ t('view.communicationPreferences.candidateAvailabilityRequests.description') }
                trailing={ <ConnectedSwitch control={ control }
                    name="communicationPreferences.candidateAvailabilityRequests"
                    disabled={ disabled }
                /> }
            />

            <InfoLine
                title={ t('view.communicationPreferences.candidateNotificationAboutOrders.title') }
                description={ t('view.communicationPreferences.candidateNotificationAboutOrders.description') }
                trailing={ <ConnectedSwitch control={ control }
                    name="communicationPreferences.candidateNotificationAboutOrders"
                    disabled={ disabled }
                /> }
            />

            <InfoLine
                title={ t('view.communicationPreferences.candidateJobPreferencesUpdateRequest.title') }
                description={ t('view.communicationPreferences.candidateJobPreferencesUpdateRequest.description') }
                trailing={ <ConnectedSwitch control={ control }
                    name="communicationPreferences.candidateJobPreferencesUpdateRequest"
                    disabled={ disabled }
                /> }
            />
        </>
    );
}
